import { GetAllResponsiblesInDto, GetAllResponsiblesOutDto } from '../../../types/responsible.dto'

export const GET_ALL_RESPONSIBLES = 'GET_ALL_RESPONSIBLES'
export const GET_ALL_RESPONSIBLES_SUCCESS = 'GET_ALL_RESPONSIBLES_SUCCESS'
export const GET_ALL_RESPONSIBLES_ERROR = 'GET_ALL_RESPONSIBLES_ERROR'
export const RESET_GET_ALL_RESPONSIBLES = 'RESET_GET_ALL_RESPONSIBLES'

export interface GetAllResponsibles {
  type: typeof GET_ALL_RESPONSIBLES
  payload: GetAllResponsiblesOutDto
}

export interface GetAllResponsiblesSuccess {
  type: typeof GET_ALL_RESPONSIBLES_SUCCESS
  payload: GetAllResponsiblesInDto
}

export interface GetAllResponsiblesError {
  type: typeof GET_ALL_RESPONSIBLES_ERROR
  payload: string | boolean
}

export interface ResetGetAllResponsibles {
  type: typeof RESET_GET_ALL_RESPONSIBLES
  payload: null
}

export interface State {
  data: GetAllResponsiblesInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetAllResponsibles | GetAllResponsiblesSuccess | GetAllResponsiblesError | ResetGetAllResponsibles
